const disputeClaimsHR = {
    "view": {
        "table": {
            "title": "Vaša kršenja autorskih prava",
            "columns": {
                "release": "Izdanja",
                "user": "Korisnik",
                "store": "Trgovina",
                "claimantName": "Ime podnositelja",
                "claimantEmail": "Email podnositelja",
                "resolutionTime": "Vrijeme rješavanja",
                "remainingTime": "Preostalo vrijeme",
                "status": "Status"
            },
            "label": {
                "status_created": "Stvoreno",
                "status_pending": "Na čekanju",
                "status_in_progress": "U tijeku",
                "status_resolved": "Riješeno",
                "status_copyright_violation": "Kršenje autorskih prava"
            },
            "button": {
                "exportCSV": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            }
        }
    }
};

export default disputeClaimsHR;